import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import userContainer from '../../../common/containers/user';
import _InlineUser from '../../../common/components/users/inlineUser.jsx';
const InlineUser = userContainer(_InlineUser);
import * as sharedStyles from '../../../common/libs/sharedStyles';

const styles = {
	icon : {
		fontSize : 16,
	},
	status : {
		fontSize : 13,
	},
	unsure : {
		color : sharedStyles.vars.colors.assessments.neutral
	},
	verifiedRow : {
		color : sharedStyles.vars.colors.assessments.positive
	}
};

function getConfirmed (userIds) {
	if (!userIds || !userIds.length) { return "Verified"; }

	return (<div>
		{userIds.map((userId, i) => {
			return (<div key={i} style={styles.verifiedRow}>
				<i style={styles.icon} className="fa fa-check"/> Verified by <InlineUser userId={userId} hideBooster={true} />
			</div>);
		})}
	</div>);
}

function getUnsure() {
	return (
		<div style={styles.unsure}>
			<i style={styles.icon} className="fa fa-info-circle" /> Venue for this game is not confirmed.
		</div>
	);
}

function GameVenueStatus (props) {
	const {status, confirmedByUserIds} = props.gameVenueStatus;

	return (
		<div style={_.assignIn({}, styles.status, props.style)}>
			{(status === 'confirm') ? getConfirmed(confirmedByUserIds) : getUnsure()}
		</div>
	);
}

GameVenueStatus.propTypes = {
	gameVenueStatus : PropTypes.object.isRequired,
};

export default GameVenueStatus;